export const shortString = (str?: string, length = 5) => {
  if (!str) return '';
  if (str.length > length) {
    return `${str.slice(0, length)}...${str.slice(-length)}`;
  }
  return str;
};
